import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import ModalHeader from "react-bootstrap/ModalHeader";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";

import { SocketContext as StreamingSocketContext } from "../../../helpers/contexts/streaming";

import "./styles/SharedComponent.css";
import CloseIcon from "../../../images/icons/close_icon.svg?react";

export default function ({ isOpen, toggleModal, isStreamerView }) {
  const navigate = useNavigate();
  const general = useSelector((state) => state.modals.general);
  const { leaveLiveStreamChannel, stopChannelStreaming } = useContext(
    StreamingSocketContext
  );

  const onConfirm = () => {
    const { data } = general;
    if (data && data.channelId && data.isStreamerView) {
      stopChannelStreaming(data.channelId);
    } else if (data && data.channelId) {
      leaveLiveStreamChannel(data.channelId, data.userId);
    }
    toggleModal();
    window.location.href = "/live";
  };

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      contentClassName="end-live-modal"
      centered
      className={`unlock verify ${
        localStorage.getItem("isDark") === "true" ? "dark" : "light"
      }`}
    >
      <ModalHeader className="end-modal d-flex w-100 align-items-center">
        <h1 className="title">Confirmation</h1>
        <CloseIcon
          className="close-icon"
          role={"button"}
          aria-label="close"
          onClick={toggleModal}
        />
      </ModalHeader>
      <ModalBody className="end-modal-body">
        {isStreamerView ? (
          <p>
            Are you sure you want to exit, closing this page means you will end
            your live session.
          </p>
        ) : (
          <p>Are you sure you want to exit ?</p>
        )}
      </ModalBody>
      <ModalFooter className="mt-1 mx-2 mb-2">
        <button onClick={toggleModal} className="action-button-default">
          Cancel
        </button>
        <button className="action-button" onClick={onConfirm}>
          Confirm
        </button>
      </ModalFooter>
    </Modal>
  );
}
